<div class="iframe-close-btn" (click)="close()">x</div>

<iframe
  [src]="iframeSrc | safe"
  frameborder="0"
  webkitallowfullscreen
  mozallowfullscreen
  allowfullscreen
></iframe>
